import { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { useViaCep } from "@/lib/viacep";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Building2 } from "lucide-react";

const FIELDS = [["legal_name", "Razão social", "sm:col-span-2"], ["cnpj", "CNPJ"], ["cep", "CEP"], ["street", "Rua", "sm:col-span-2"], ["number", "Número"],
  ["neighborhood", "Bairro"], ["city", "Cidade"], ["uf", "UF"]];

export function CompanyCard() {
  const [f, setF] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/shop-settings/company").then(({ data }) => setF(data || {})).catch(() => setF({})); }, []);
  useViaCep(f?.cep, (d) => setF((p) => ({
    ...p,
    street: d.logradouro || p?.street,
    neighborhood: d.bairro || p?.neighborhood,
    city: d.localidade || p?.city,
    uf: (d.uf || "").toUpperCase() || p?.uf,
  })));
  const save = async () => {
    setBusy(true);
    try { const { data } = await api.put("/shop-settings/company", f); setF(data); toast.success("Dados da empresa salvos"); }
    catch (e) { toast.error(formatApiError(e)); } finally { setBusy(false); }
  };
  if (!f) return null;
  return (
    <section data-testid="company-card" className="rounded-2xl border border-card2-border bg-card2 p-4 space-y-3">
      <div className="flex items-center gap-2 font-bold text-zinc-100"><Building2 className="h-4 w-4" /> Dados da empresa (cabeçalho dos PDFs)</div>
      <div className="grid grid-cols-1 sm:grid-cols-4 gap-2">
        {FIELDS.map(([k, l, cls]) => (
          <Input key={k} data-testid={`company-${k}`} value={f[k] || ""} onChange={(e) => setF((p) => ({ ...p, [k]: e.target.value }))} placeholder={l} className={`bg-zinc-900 border-zinc-800 ${cls || ""}`} />
        ))}
      </div>
      <Button size="sm" data-testid="company-save" disabled={busy} onClick={save} className="bg-green-brand text-white">Salvar</Button>
    </section>
  );
}
